import React, { useContext, useMemo } from 'react';

interface ReviewContext {
  isProject?: boolean
  isReview?: boolean
  isFree?: boolean
  isPdf?: boolean
  isAssistant?: boolean
  isExtension?: boolean
  isLeadgen?: boolean
  isWebflow?: boolean
  isReviewTeaser?: boolean
  hasReviewTeaserUrl?: boolean
  variant?: string | null
  isDudaEditor?: boolean
  isShopify?: boolean
}

const ReviewContext = React.createContext<ReviewContext>({
  isProject: false,
  isReview: false,
  isFree: false,
  isPdf: false,
  isAssistant: false,
  isExtension: false,
  isLeadgen: false,
  isWebflow: false,
  isReviewTeaser: false,
  hasReviewTeaserUrl: false,
  variant: null,
  isDudaEditor: false,
  isShopify: false
});

interface ReviewProviderProps extends ReviewContext {
  children?: React.ReactNode
}

export function ReviewProvider ({
  isProject = false,
  isReview = false,
  isFree = false,
  isPdf = false,
  isAssistant = false,
  isExtension = false,
  isLeadgen = false,
  isWebflow = false,
  children,
  isReviewTeaser = false,
  hasReviewTeaserUrl = false,
  variant = null,
  isDudaEditor = false,
  isShopify = false
}: ReviewProviderProps) {
  const value = useMemo(() => ({
    isProject,
    isReview,
    isFree,
    isPdf,
    isAssistant,
    isExtension,
    isLeadgen,
    isWebflow,
    children,
    isReviewTeaser,
    hasReviewTeaserUrl,
    variant,
    isDudaEditor,
    isShopify
  }), [
    isProject,
    isReview,
    isFree,
    isPdf,
    isAssistant,
    isExtension,
    isLeadgen,
    isWebflow,
    children,
    isReviewTeaser,
    hasReviewTeaserUrl,
    variant,
    isDudaEditor,
    isShopify
  ]);
  return (
    <ReviewContext.Provider value={value}>
      {children}
    </ReviewContext.Provider>
  );
}

export const useReviewContext = () => useContext(ReviewContext);

export default ReviewContext;
